<!--
 * @Author: your name
 * @Date: 2021-08-11 09:07:22
 * @LastEditTime: 2021-09-08 17:21:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\pages\exclusivePurchase\reviewPurchase.vue
-->
<template>
  <div class="content_wrapper">
      <headerTop></headerTop>
      <brandmall-header :logoImg='logoImg' :mallName="mallName"></brandmall-header>
      <div class="content_box">
        <div class="content_top flex">
            <div class="content_top_l">
               <mallCategory  :allCategoriesList="controlData.allCategoriesList"></mallCategory>
            </div>
            <div class="content_top_m">
              <el-carousel height="346px" arrow="never">
                <el-carousel-item v-for="(item,index) in controlData.bannerList" :key="index" >
                  <el-image @click="toPath(item)" :src="item.imgUrl"  fit="fit" style="width:834px;height:346px"></el-image>
                </el-carousel-item>
            </el-carousel> 
            </div>
            <div class="content_top_r">
              <bulk-material></bulk-material>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
import cmsOssApi from  '../../api/cms-oss/index.js';
import headerTop from '../../components/mallHeader/header-top.vue'
import brandmallHeader from '../../components/exclusivePurchase/brandmall-header.vue'
import mallCategory from "./mallCategory.vue";
import bulkMaterial from "./bulkMaterial.vue";
export default {
     components: {
        headerTop,
        brandmallHeader,
        mallCategory,
        bulkMaterial
     },
     data(){
         return{
            userInfo:{},
            logoImg:'',
            mallName:'',
            controlData:{
                bannerList:[],
                allCategoriesList:[],
            },
           
         }
     },
     created(){
          this.userInfo=this.$store.state.USERINFO;
         this.getOssTemplate()
         this.purchaseAreaCategory()
        //  this.getPurchaseTemplate()
     },
     methods:{
         //获取生效中模板
        async getOssTemplate(){
            let params={
                companyId:this.userInfo.companyId,
                columeId:4,  //1 首页 2 店铺   3 旗舰店 
                shopId:0
            }
            let res =await cmsOssApi.getShopTemplateossUrl(params);
             if(res.data){
                let list=[]
                res.data.fileList.forEach(item => {
                list.push({
                    name:item.name,
                    imgUrl:item.url
                })
                });
                this.controlData.bannerList=list
                if(typeof(res.data.logoImgList)=='string'){
                    this.logoImg =res.data.logoImgList
                }else{
                    this.logoImg = res.data.logoImgList[0];
                }
                this.mallName=res.data.mallName
               
                
            }
        },
        // async getPurchaseTemplate(){
        //     let res = await cmsApi.queryPurchaseTemplate();
        //     if(res.data){
        //             let page=JSON.parse(res.data.draftTemplate)
        //             let arr=[]
        //             page.fileList.forEach(item=>{
        //                 arr.push({
        //                     imgUrl:item.url
        //                 })
        //             })
        //             this.controlData.bannerList=arr
        //             if(typeof(res.data.logoImgList)=='string'){
        //                 this.logoImg =res.data.logoImgList
        //             }else{
        //                 this.logoImg = res.data.logoImgList[0];
        //             }
        //             this.mallName=res.data.mallName
        //             }
        //         },
        //获取已设置分类
        async purchaseAreaCategory(){
            let params={
                companyId:this.userInfo.companyId,
            }
     
            let res =await cmsOssApi.purchaseAreaCategory(params);
            if(res.data.categoryList){
                this.controlData.allCategoriesList=res.data.categoryList
            }
        },
     }

}
</script>

<style lang='scss' scoped>
@import '../../../../assets/css/theme.scss';
.content_wrapper {
  .content_box {
    width: 1200px;
    margin: 0 auto;
    background: #fff;
    margin-top:20px;
  }
  .content_top{
    width: 1200px;
    height:346px;
    .content_top_l{
      width: 180px;
    }
    .content_top_m{
      flex:1;
    }
    .content_top_r{
      width: 186px;
    }

  }
  
}
 
</style>